import React from 'react';

const ErrorMessageTitle = ({ children }) => (
  <div className="error-message-title">{children}</div>
);

export default ErrorMessageTitle;
